<div *ngIf="showIntro" class="intro-overlay" (keyup.escape)="hideIntro()">
	<div class="intro-center">
		<swiper-container
			pagination="true"
			slidesPerView="1"
			initialSlide="0"
			speed="400"
			grabCursor="true"
			centeredSlides="true"
			#slides
		>
			<swiper-slide>
				<div class="slide">
					<div class="main-div">
						<div class="child-div-1">
							<div class="child-div-1-inner">
								<h2>
									{{ introConfig?.WELCOME_TITLE_1 | translate }} <br />
									{{ introConfig?.WELCOME_TITLE_2 | translate }}
								</h2>
							</div>
						</div>
						<div class="child-div-2">
							<img
								src="{{ welcomeImageSrc }}"
								alt=""
								id="clientIntroWelcomeContentImg"
								class="img-responsive"
								style="max-width: 100%; max-height: 300px; margin: 0px; align-self: center"
							/>
						</div>
						<div class="child-div-3">
							<div class="child-div-3-inner">
								<p>
									{{ introConfig?.WELCOME_PARAGRAPH | translate }}
								</p>
							</div>
						</div>
						<div class="child-div-4">
							<div class="child-div-4-inner">
								<a
									#skipit
									href="javascript:void(0)"
									(click)="hideIntro()"
									style="text-decoration: none; padding-right: 10px"
									>{{ introConfig?.SKIP | translate }}</a
								>
								|
								<a
									href="javascript:void(0)"
									(click)="next()"
									style="text-decoration: none; padding-left: 10px"
									>{{ introConfig?.NEXT | translate }}</a
								>
							</div>
						</div>
					</div>
				</div>
			</swiper-slide>
			<swiper-slide *ngFor="let item of introConfig?.introItems">
				<div class="slide">
					<div class="main-div">
						<div class="child-div-1">
							<div class="child-div-1-inner">
								<h2>{{ item.INTRO_ITEM_TITLE | translate }}</h2>
							</div>
						</div>
						<div class="child-div-2">
							<img
								src="{{ item.INTRO_ITEM_IMAGE | translate }}"
								alt=""
								class="img-responsive"
								style="max-width: 100%; max-height: 100%; margin: 0px; align-self: center"
							/>
						</div>
						<div class="child-div-3">
							<div class="child-div-3-inner">
								<p>
									{{ item.INTRO_ITEM_PARAGRAPH | translate }}
								</p>
							</div>
						</div>
						<div class="child-div-4">
							<div class="child-div-4-inner">
								<a
									href="javascript:void(0)"
									(click)="hideIntro()"
									style="text-decoration: none; padding-right: 10px"
									*ngIf="item.INTRO_ITEM_ID < introConfig?.introItems?.length"
									>{{ introConfig?.SKIP | translate }}</a
								>
								<span *ngIf="item.INTRO_ITEM_ID < introConfig?.introItems?.length">|</span>
								<a
									href="javascript:void(0)"
									(click)="next()"
									style="text-decoration: none; padding-left: 10px"
									*ngIf="item.INTRO_ITEM_ID < introConfig?.introItems?.length"
									>{{ introConfig?.NEXT | translate }}</a
								>
								<a
									href="javascript:void(0)"
									(click)="hideIntro()"
									style="text-decoration: none"
									*ngIf="item.INTRO_ITEM_ID == introConfig?.introItems?.length"
									>{{ introConfig?.DONE | translate }}</a
								>
							</div>
						</div>
					</div>
				</div>
			</swiper-slide>
		</swiper-container>
	</div>
</div>
